import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from "react";
import { AssetMobileVersionsItem } from "~/_components/AssetMobileVersionsListItem";
import { AssetMobileVersionsListTitle } from "~/_components/AssetMobileVersionsListTitle";
export const AssetMobileVersionsList = /*#__PURE__*/ memo((param)=>{
    let { renderVersion, title, versions } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex flex-col gap-4",
        children: [
            /*#__PURE__*/ _jsx(AssetMobileVersionsListTitle, {
                children: title
            }),
            versions.map((version)=>!!renderVersion ? renderVersion(version) : /*#__PURE__*/ _jsx(AssetMobileVersionsItem, {
                    version: version
                }, version.id))
        ]
    });
});
AssetMobileVersionsList.displayName = "AssetMobileVersionsList";
